window.addEventListener('alpine:init', bootstrap);
export default () => ({
	observer: null,
	$items: [],
	init() {
		this.$items = this.$root.querySelectorAll('.vc_row');
		this.setupObserver();
	},
	setupObserver() {
		if ( this.observer !== null ) { return; }

		const options = {
			rootMargin: '-45% 0% -45% 0%',
			// rootMargin: '-250px 0px -250px 0px',
			threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
		};
		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach( (entry) => {
					if ( entry.isIntersecting ) {
						entry.target.classList.add('is-active');
					} else {
						entry.target.classList.remove('is-active');
					}
				} );
			},
			options
		);

		this.$items.forEach( $$ => this.observer.observe($$) );

	}
});

function bootstrap() {
	console.log('bootstrap features interface!');
	document.querySelectorAll('.js-features-interface').forEach(
		$$ => bootstrapInterface($$)
	);
}

function bootstrapInterface($el) {
	$el.setAttribute('x-data', 'featuresInterface');
}
